<template>
  <div id="root">
    <div v-if="!isMobile">
      This is a webapp and is only available on mobile. Try it out on your
      phone!
    </div>

    <div v-if="isMobile" id="app">
      <!-- FIXED POSITION COMPONENTS ------------>
      <div id="canvas-container">
        <canvas id="bg-text"></canvas>
      </div>
      <navbar />
      <menu-icon v-on:click.native="isMenuToggled = !isMenuToggled" />
      <div class="side-menu" v-bind:class="{ toggled: isMenuToggled }">
        <div class="links">
          <div
            v-on:click="
              currentPage = 'home';
              isMenuToggled = false;
            "
          >
            HOME
          </div>
          <div
            v-on:click="
              currentPage = 'info';
              isMenuToggled = false;
            "
          >
            INFO
          </div>
          <div
            v-on:click="
              currentPage = 'photos';
              isMenuToggled = false;
            "
          >
            PHOTOS
          </div>
          <div
            v-on:click="
              currentPage = 'links';
              isMenuToggled = false;
            "
          >
            LINKS
          </div>
          <div
            v-on:click="
              currentPage = 'credits';
              isMenuToggled = false;
            "
          >
            CREDITS
          </div>
          <div
            class="close-menu-btn"
            v-bind:class="{ toggled: isMenuToggled }"
            v-on:click="isMenuToggled = !isMenuToggled"
          >
            x
          </div>
        </div>
      </div>

      <!-- VIEWS -------------------------------->
      <home-page v-if="currentPage == 'home'" />
      <info-page v-if="currentPage == 'info'" />
      <photos v-if="currentPage == 'photos'" />
      <links-page v-if="currentPage == 'links'" />
      <credits-page v-if="currentPage == 'credits'" />
    </div>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import MenuIcon from "./components/MenuIcon.vue";
import InfoPage from "./components/InfoPage.vue";
import HomePage from "./components/HomePage.vue";
import Photos from "./components/Photos.vue";
import CreditsPage from "./components/CreditsPage.vue";
import LinksPage from "./components/LinksPage.vue";
import opentype from "opentype.js";

export default {
  name: "App",
  components: {
    Navbar,
    MenuIcon,
    InfoPage,
    HomePage,
    CreditsPage,
    Photos,
    LinksPage,
  },
  data: () => ({
    isMenuToggled: false,
    currentPage: "home",
  }),
  computed: {
    isMobile: function () {
      return window.innerWidth < 800;
    },
    container: function () {
      return document.querySelector("#canvas-container");
    },
  },
  methods: {
    redraw: function () {
      const ctx = document.querySelector("#bg-text").getContext("2d");
      ctx.clearRect(
        0,
        0,
        this.container.innerWidth,
        this.container.innerHeight
      );
      this.drawBackground();
    },
    drawBackground: function () {
      opentype.load(
        "https://cdn.glitch.com/1272abfd-c3bb-417e-af76-59727da0cce9%2FBison-Bold.ttf?v=1613126905149",
        (err, font) => {
          if (err) {
            console.log("font not loaded");
            alert("Font could not be loaded");
          } else {
            console.log("font successfuly loaded");
            const ctx = document.querySelector("#bg-text").getContext("2d");
            const container = document.querySelector("#canvas-container");
            ctx.canvas.width = container.offsetWidth;
            ctx.canvas.height = container.offsetHeight;
            let paths = [];
            paths.push(font.getPath("HEAR THE", 0, 200, 72));
            paths.push(font.getPath("VOICE OF", 0, 200, 72));
            paths.push(font.getPath("MYANMAR", 0, 200, 72));
            this.drawPaths(paths, ctx);
          }
        }
      );
    },
    mapVal: function (n, start1, stop1, start2, stop2) {
      return ((n - start1) / (stop1 - start1)) * (stop2 - start2) + start2;
    },
    drawPaths: function (paths, ctx) {
      const rowHeight = this.container.offsetHeight / 3;
      const p = 15; // padding
      for (let i in paths) {
        console.log("drawing path " + i);
        const path = paths[i];
        //GET CORNERS
        var filtered = path.commands.filter((pt) => pt.type != "Z");
        const rmin = filtered.reduce((a, b) => ({
          x: Math.min(a.x, b.x),
          y: Math.min(a.y, b.y),
        }));
        var rmax = filtered.reduce((a, b) => ({
          x: Math.max(a.x, b.x),
          y: Math.max(a.y, b.y),
        }));
        const minX = rmin.x;
        const minY = rmin.y;
        const maxX = rmax.x;
        const maxY = rmax.y;
        //MUTATE PATH
        let y1 = 0 + rowHeight * i + p;
        let y2 = rowHeight - p + rowHeight * i;
        let x1 = 0 + p;
        let x2 = this.container.offsetWidth - p;
        for (let j in path.commands) {
          if (path.commands[j].type != "Z") {
            let curX = path.commands[j].x;
            let curY = path.commands[j].y;
            path.commands[j].x = this.mapVal(curX, minX, maxX, x1, x2);
            path.commands[j].y = this.mapVal(curY, minY, maxY, y1, y2);
            if (path.commands[j].type == "Q") {
              let curX1 = path.commands[j].x1;
              let curY1 = path.commands[j].y1;
              path.commands[j].x1 = this.mapVal(curX1, minX, maxX, x1, x2);
              path.commands[j].y1 = this.mapVal(curY1, minY, maxY, y1, y2);
            }
          }
        }
        path.fill = "rgba(242,227,130,0.2)";
        path.draw(ctx);
      }
    },
  },
  mounted: function () {
    this.drawBackground();
    window.addEventListener("resize", this.redraw);
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&family=Oswald&display=swap");
@font-face {
  font-family: "LoudAndClear";
  src: local("LoudAndClear"),
    url("./assets/fonts/LoudAndClear.otf") format("opentype");
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: "Lato";
}

.white {
  color: white;
}

.black {
  color: black;
}

.red {
  color: #c92629;
}

body {
  background: black;
}
.toggled {
  left: 0 !important;
}

.side-menu {
  transition: left 1s;
  position: fixed;
  top: 0;
  left: -45vw;
  width: 45vw;
  height: 100vh;
  background: black;
  color: white;
  font-size: 1.5em;
  z-index: 99;
}

.side-menu > .links {
  margin: 15vh 5vw;
}

.side-menu > .links > div {
  margin-top: 5vh;
  font-family: "Oswald";
  cursor: pointer;
}

.close-menu-btn {
  transition: left 1s;
  position: absolute;
  top: 0;
  left: -5vw;
  margin-left: 35vw;
  cursor: pointer;
}
.page-header {
  font-family: "Oswald";
  font-size: 2.5em;
  color: white;
}

#canvas-container {
  position: fixed;
  width: 100vw;
  top: 8vh;
  height: 92vh;
}
</style>
